import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService, UserRole } from '../services/session.service';

export function roleGuard(...allowed: UserRole[]): CanActivateFn {
  return () => {
    const session = inject(SessionService);
    const router = inject(Router);
    if (allowed.includes(session.role())) return true;
    return router.createUrlTree([session.homePath()]);
  };
}
